module.exports = __webpack_public_path__ + "static/zyppys-logo-f44bc559c7ae5e84e0552af9fff99d91.png";